import {allRequest, getRequest, postRequest, REQUEST_METHOD_GET} from '../../../../../middlewares/api/actions';
import {
  getAllCubeUrl,
  getCubeUrl,
  getDcsUrl,
  getFileMappingUrl,
  getFileMappingByFormatUrl,
  getPaginatedCodelistUrl,
  getSequenceMappingUrl,
  getUpdateFileMappingUrl
} from '../../../../../constants/urls';

export const LOADER_CSV_FORM_MAPPING_CONTROL_MAPPING_SET = 'LOADER_CSV_FORM_MAPPING_CONTROL_MAPPING_SET';
export const LOADER_CSV_FORM_MAPPING_CONTROL_MAPPING_UNSET = 'LOADER_CSV_FORM_MAPPING_CONTROL_MAPPING_UNSET';
export const LOADER_CSV_FORM_MAPPING_CONTROL_MAPPINGS_SHOW = 'LOADER_CSV_FORM_MAPPING_CONTROL_MAPPINGS_SHOW';
export const LOADER_CSV_FORM_MAPPING_CONTROL_DETAIL_MAPPING_SHOW = 'LOADER_CSV_FORM_MAPPING_CONTROL_DETAIL_MAPPING_SHOW';
export const LOADER_CSV_FORM_MAPPING_CONTROL_SELECTED_MAPPING_SHOW = 'LOADER_CSV_FORM_MAPPING_CONTROL_SELECTED_MAPPING_SHOW';
export const LOADER_CSV_FORM_MAPPING_CONTROL_MAPPINGS_HIDE = 'LOADER_CSV_FORM_MAPPING_CONTROL_MAPPINGS_HIDE';
export const LOADER_CSV_FORM_MAPPING_CONTROL_DETAIL_MAPPING_HIDE = 'LOADER_CSV_FORM_MAPPING_CONTROL_DETAIL_MAPPING_HIDE';
export const LOADER_CSV_FORM_MAPPING_CONTROL_SELECTED_MAPPING_HIDE = 'LOADER_CSV_FORM_MAPPING_CONTROL_SELECTED_MAPPING_HIDE';
export const LOADER_CSV_FORM_MAPPING_CONTROL_MAPPINGS_READ = 'LOADER_CSV_FORM_MAPPING_CONTROL_MAPPINGS_READ';
export const LOADER_CSV_FORM_MAPPING_CONTROL_DETAIL_MAPPING_READ = 'LOADER_CSV_FORM_MAPPING_CONTROL_DETAIL_MAPPING_READ';
export const LOADER_CSV_FORM_MAPPING_CONTROL_DETAIL_MAPPING_CUBE_READ = 'LOADER_CSV_FORM_MAPPING_CONTROL_DETAIL_MAPPING_CUBE_READ';
export const LOADER_CSV_FORM_MAPPING_CONTROL_SELECTED_MAPPING_READ = 'LOADER_CSV_FORM_MAPPING_CONTROL_SELECTED_MAPPING_READ';
export const LOADER_CSV_FORM_MAPPING_CONTROL_SELECTED_MAPPING_CUBE_READ = 'LOADER_CSV_FORM_MAPPING_CONTROL_SELECTED_MAPPING_CUBE_READ';
export const LOADER_CSV_FORM_MAPPING_CONTROL_SEQUENCE_MAPPING_SET = 'LOADER_CSV_FORM_MAPPING_CONTROL_SEQUENCE_MAPPING_SET';
export const LOADER_CSV_FORM_MAPPING_CONTROL_SELECTED_SEQUENCE_MAPPING_HIDE = 'LOADER_CSV_FORM_MAPPING_CONTROL_SELECTED_SEQUENCE_MAPPING_HIDE';
export const LOADER_CSV_FORM_MAPPING_CONTROL_DETAIL_SEQUENCE_MAPPING_SHOW = 'LOADER_CSV_FORM_MAPPING_CONTROL_DETAIL_SEQUENCE_MAPPING_SHOW';
export const LOADER_CSV_FORM_MAPPING_CONTROL_DETAIL_SEQUENCE_MAPPING_HIDE = 'LOADER_CSV_FORM_MAPPING_CONTROL_DETAIL_SEQUENCE_MAPPING_HIDE';
export const LOADER_CSV_FORM_MAPPING_CONTROL_DETAIL_SEQUENCE_MAPPING_READ = 'LOADER_CSV_FORM_MAPPING_CONTROL_DETAIL_SEQUENCE_MAPPING_READ';
export const LOADER_CSV_FORM_MAPPING_CONTROL_SELECTED_SEQUENCE_MAPPING_READ = 'LOADER_CSV_FORM_MAPPING_CONTROL_SELECTED_SEQUENCE_MAPPING_READ';
export const LOADER_CSV_FORM_MAPPING_CONTROL_SEQUENCE_MAPPING_SET_INDEX = 'LOADER_CSV_FORM_MAPPING_CONTROL_SEQUENCE_MAPPING_SET_INDEX'
export const LOADER_CSV_FORM_MAPPING_CONTROL_FIXED_COMPONENT_VALUE_SET = 'LOADER_CSV_FORM_MAPPING_CONTROL_FIXED_COMPONENT_VALUE_SET';
export const LOADER_CSV_FORM_MAPPING_CONTROL_CODELIST_CODES_ITEMS_PAGE_READ = 'LOADER_CSV_FORM_MAPPING_CONTROL_CODELIST_CODES_ITEMS_PAGE_READ';
export const LOADER_CSV_FORM_MAPPING_CONTROL_MAPPING_UPDATE = 'LOADER_CSV_FORM_MAPPING_CONTROL_MAPPING_UPDATE';
export const LOADER_CSV_FORM_MAPPING_CONTROL_MAPPING_MODIFIED_SET = 'LOADER_CSV_FORM_MAPPING_CONTROL_MAPPING_MODIFIED_SET';

export const setLoaderCsvFormMappingControlMapping = mappingId => ({
  type: LOADER_CSV_FORM_MAPPING_CONTROL_MAPPING_SET,
  mappingId
});

export const unsetLoaderCsvFormMappingControlMapping = () => ({
  type: LOADER_CSV_FORM_MAPPING_CONTROL_MAPPING_UNSET
});

export const showLoaderCsvFormMappingControlMappings = () => ({
  type: LOADER_CSV_FORM_MAPPING_CONTROL_MAPPINGS_SHOW
});

export const showLoaderCsvFormMappingControlDetailMapping = mappingId => ({
  type: LOADER_CSV_FORM_MAPPING_CONTROL_DETAIL_MAPPING_SHOW,
  mappingId
});

export const showLoaderCsvFormMappingControlSelectedMapping = () => ({
  type: LOADER_CSV_FORM_MAPPING_CONTROL_SELECTED_MAPPING_SHOW,
});

export const hideLoaderCsvFormMappingControlMappings = () => ({
  type: LOADER_CSV_FORM_MAPPING_CONTROL_MAPPINGS_HIDE
});

export const hideLoaderCsvFormMappingControlDetailMapping = () => ({
  type: LOADER_CSV_FORM_MAPPING_CONTROL_DETAIL_MAPPING_HIDE
});


export const hideLoaderCsvFormMappingControlSelectedMapping = () => ({
  type: LOADER_CSV_FORM_MAPPING_CONTROL_SELECTED_MAPPING_HIDE
});

export const readLoaderCsvFormMappingControlMappings = (format, pluginId, sequenceMappingEnabled) => {
  const seqMappingMethod = sequenceMappingEnabled ? [REQUEST_METHOD_GET] : [];
  const seqMappingUrl = sequenceMappingEnabled ? [getSequenceMappingUrl(null, pluginId)] : [];

  return ({
    ...allRequest(
      LOADER_CSV_FORM_MAPPING_CONTROL_MAPPINGS_READ,
      [REQUEST_METHOD_GET, REQUEST_METHOD_GET, REQUEST_METHOD_GET].concat(seqMappingMethod),
      [getAllCubeUrl(), getDcsUrl(), getFileMappingByFormatUrl(format, pluginId)].concat(seqMappingUrl)      
    ),
    format,
    sequenceMappingEnabled,
    pluginId
  });
};

export const readLoaderCsvFormMappingControlDetailMapping = mappingId => getRequest(
  LOADER_CSV_FORM_MAPPING_CONTROL_DETAIL_MAPPING_READ,
  getFileMappingUrl(mappingId)
);

export const readLoaderCsvFormMappingControlDetailMappingCube = cubeId => getRequest(
  LOADER_CSV_FORM_MAPPING_CONTROL_DETAIL_MAPPING_CUBE_READ,
  getCubeUrl(cubeId)
);

export const readLoaderCsvFormMappingControlSelectedMapping = mappingId => getRequest(
  LOADER_CSV_FORM_MAPPING_CONTROL_SELECTED_MAPPING_READ,
  getFileMappingUrl(mappingId)
);

export const readLoaderCsvFormMappingControlSelectedMappingCube = cubeId => getRequest(
  LOADER_CSV_FORM_MAPPING_CONTROL_SELECTED_MAPPING_CUBE_READ,
  getCubeUrl(cubeId)
);

export const setLoaderCsvFormMappingControlSequenceMapping = (sequenceMappingId, sequenceMappingMappings) => ({
  type: LOADER_CSV_FORM_MAPPING_CONTROL_SEQUENCE_MAPPING_SET,
  sequenceMappingId,
  sequenceMappingMappings
});

export const showLoaderCsvFormMappingControlDetailSequenceMapping = sequenceMappingId => ({
  type: LOADER_CSV_FORM_MAPPING_CONTROL_DETAIL_SEQUENCE_MAPPING_SHOW,
  sequenceMappingId
});

export const hideLoaderCsvFormMappingControlDetailSequenceMapping = sequenceMappingId => ({
  type: LOADER_CSV_FORM_MAPPING_CONTROL_DETAIL_SEQUENCE_MAPPING_HIDE,
  sequenceMappingId
});

export const readLoaderCsvFormMappingControlDetailSequenceMapping = sequenceMappingId => getRequest(
  LOADER_CSV_FORM_MAPPING_CONTROL_DETAIL_SEQUENCE_MAPPING_READ,
  getSequenceMappingUrl(sequenceMappingId)
);

export const readLoaderCsvFormMappingControlSelectedSequenceMapping = (selectedMappingId, mappingsTree) => ({
  ...getRequest(
    LOADER_CSV_FORM_MAPPING_CONTROL_SELECTED_SEQUENCE_MAPPING_READ,
    getSequenceMappingUrl(selectedMappingId)
  ),
  selectedMappingId,
  mappingsTree
});

export const setLoaderCsvFormMappingControlSequenceMappingIndex = index => ({
  type: LOADER_CSV_FORM_MAPPING_CONTROL_SEQUENCE_MAPPING_SET_INDEX,
  index
});

export const readLoaderCsvFormMappingControlCodelistCodesItemsPage = ({
  codelistTriplet,
  language,
  pageNum,
  pageSize,
  searchText,
  filters,
  sortCol,
  sortByDesc,
  componentName
}
) => ({
...postRequest(
  LOADER_CSV_FORM_MAPPING_CONTROL_CODELIST_CODES_ITEMS_PAGE_READ,
  getPaginatedCodelistUrl(),
  ({
    Id: codelistTriplet.id,
    AgencyId: codelistTriplet.agencyID,
    Version: codelistTriplet.version,
    Lang: language,
    PageNum: pageNum,
    PageSize: pageSize,
    AllSearch: searchText,
    CodeSearch: filters.id ? filters.id : undefined,
    NameSearch: filters.name ? filters.name : undefined,
    ParentSearch: filters.parent ? filters.parent : undefined,
    SortColumn: sortCol ? sortCol : undefined,
    SortDesc: sortByDesc ? sortByDesc : undefined,
    rebuildDb: false
  })
),
componentName
});	


export const updateLoaderCsvFormMappingControlMapping = (fileMapping) => {
  return {
    ...postRequest(
      LOADER_CSV_FORM_MAPPING_CONTROL_MAPPING_UPDATE,
      getUpdateFileMappingUrl(),
      fileMapping,
      t => ({
        success: t('scenes.dataManager.loader.csvForm.mappingControl.fileMappingUpdate.success')
      })
    )}
};

export const setLoaderCsvFormMappingControlMappingModified = value => ({
  type: LOADER_CSV_FORM_MAPPING_CONTROL_MAPPING_MODIFIED_SET,
  value
});
